export const ACCESS_TOKEN_COOKIE_NAME = 'accessToken';
export const REFRESH_TOKEN_COOKIE_NAME = 'refreshToken';
export const CSRFTOKEN = 'csrftoken';
export const TOKEN_EXPIRATION_ERROR = 'Signature has expired';
export const AUTHENTICATION_REQUIRED_ERROR = 'AUTHENTICATION_REQUIRED';
export const ERROR_DECODING_SIGNATURE = 'Error decoding signature';
